module.exports = __webpack_public_path__ + "img/celeri.8cceb91a.svg";